/**
 * Handles product carousel
 * @todo rename this file from product-swiper.js to productCarousel.js
 */
function doProductCarousel() {
  if (customElements.get("product-carousel")) return null;

  class ProductCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector(".product-carousel-slider");
      this.variantRadios = document.querySelectorAll(
        ".product__info-container variant-radios"
      );
      this.init();
    }

    init() {
      this.initSwiper();
    }

    /**
     * initializes the slider and assigns each variant radio to a listener('change')
     * @returns void
     */
    initSwiper() {
      const swiper = new Swiper(this.slider, {
        direction: "horizontal",
        loop: true,
        autoHeight: true,
        navigation: {
          nextEl: ".product-carousel-next",
          prevEl: ".product-carousel-prev",
        },
        pagination: {
          el: ".product-carousel-pagination",
          clickable: true,
        },
      });

      this.slideTo(swiper);
      if (this.variantRadios == null) return null;

      this.variantRadios.forEach((labelBtn) => {
        labelBtn.addEventListener("change", () => {
          this.slideTo(swiper);
        });
      });
    }

    /**
     * Checks url for params of 'variant' and slides the slider to the variant image if it exist
     * @param {Swiper} swiper
     * @returns void
     */
    slideTo(swiper) {
      const url = new URL(window.location.href);
      if (url == null) return null;
      const params = new URLSearchParams(url.search);
      if (params == null) return null;
      const selectedVariantId = parseFloat(params.get("variant"));
      if (selectedVariantId == null) return null;

      const slideItem = this.querySelector(
        `.swiper-slide[data-slide-variant-id="${selectedVariantId}"]`
      );
      if (slideItem == null) return null;
      swiper.slideTo(parseFloat(slideItem.dataset.swiperSlideIndex) + 1);
    }
  }

  customElements.define("product-carousel", ProductCarousel);
}
doProductCarousel();
